import { AnyAction, Dispatch } from '@reduxjs/toolkit';
import moment from 'moment';
import store from '../../../store/store';
import { CMDSpBetLogFailQuery, ICommand } from '../live';
import { AbstractHandler } from './AbstractHandler';
import {
    Bet,
    betRecordSliceActions,
    BetRecordState,
} from '@/modules/report/slice/betRecord';
import { getBetRecordReportState } from '@/modules/report/selector';

export class CMDSpBetLogFailQueryHandler extends AbstractHandler {
    _command: CMDSpBetLogFailQuery;
    constructor(command: ICommand) {
        super();
        this._command = command as CMDSpBetLogFailQuery;
    }
    handle(dispatch: Dispatch<AnyAction>): void {
        const state = store.getState();
        const { records, total } = getBetRecordReportState(state);

        const newRecords: BetRecordState['records'] = JSON.parse(
            JSON.stringify(records)
        );
        for (let b of this._command.Bet) {
            if (Object.keys(newRecords).length >= total) break;
            // the UTCSecond has been include the timezone (UTC+8), so do not do any change before server has change the timestamp to UTC
            const m = moment.unix(b.UTCSecond).utc(false);
            const d = m.format('yyyy-MM-DD');
            const t = m.format('HH:mm:ss');

            const bet = {} as Bet;
            bet.BetAmount = b.BetAmount;
            bet.BetType = b.BetType;
            const gameCount = b.GameCount;
            bet.GameCount = gameCount;
            bet.Shoes = Math.floor(gameCount / 10000);
            bet.Round = gameCount % 10000;
            bet.GameID = b.GameID;
            bet.GameType = b.GameType;
            bet.HostID = b.HostID;
            bet.Reason = b.Reason;

            bet.Date = d;
            bet.Time = t;

            if (!newRecords[d])
                newRecords[d] = {
                    bets: new Array<Bet>(),
                    totalAmount: 0,
                    allGameType: 0,
                };
            newRecords[d].bets.push(bet);
        }
        dispatch(
            betRecordSliceActions.updateRecord({
                records: newRecords,
            })
        );
    }
}
